import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { COLOR } from 'vars/color'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
  ButtonIconSizes,
  IconPositions,
} from '../Button.h'

export interface IGhostButtonProps extends IButtonProps {}

export const GhostButtonTemplate = ({
  icon,
  iconPosition = IconPositions.Left,
  iconSize = ButtonIconSizes.medium,
  corners = ButtonCorners.CORNERS_10,
  colorDefault = ButtonColors.COLOR_PRIMARY,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault = COLOR.TRANSPARENT,
  backgroundColorDisabled = COLOR.TRANSPARENT,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font = ButtonFonts.Button1,
  fluid = ButtonFluid.None,
  onClick,
  ...rest
}: IGhostButtonProps): JSX.Element => {
  return (
    <Button
      icon={icon}
      iconPosition={iconPosition}
      iconSize={iconSize}
      corners={corners}
      colorDefault={colorDefault}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      font={font}
      fluid={fluid}
      onClick={onClick}
      {...rest}
    />
  )
}
